export class PerformanceHistoryItem {

  public id: string;
  public score: string;
  public testedUrl: string;
  public grade: string;
  public loadTime: number;
  public pageSize: number;
  public requestsCount: number;
  public testedAt: Date;

}
